import React, { useState, useEffect } from "react";
import { Tooltip } from "react-tooltip";
import { Link } from "react-router-dom"; // <-- Import Link
import "./Map.css"; // Ensure you have styles for the .active class
import new1Map from "../photos/newmap.png";
import Slider from "react-slick";

const sliderSettings = {
  dots: true,
  infinite: true,
  speed: 1000,
  slidesToShow: 3,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 2500,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
      },
    },
  ],
};

const markers = [
    {
        name: "India",
        className: "marker-india",
        tooltip: "<strong>India</strong><p>2000+ students</p><p>80% success rate</p>",
    },
    {
        name: "Canada",
        className: "marker-canada",
        tooltip: "<strong>Canada</strong><p>20,000+ students</p><p>50% success rate</p>",
    },
    {
        name: "Europe",
        className: "marker-europe",
        tooltip: "<strong>Europe</strong><p>50,000+ students</p><p>90% success rate</p>",
    },
    {
        name: "Australia",
        className: "marker-australia",
        tooltip: "<strong>Australia</strong><p>10,000+ students</p><p>60% success rate</p>",
    },
    {
        name: "United States",
        className: "marker-us",
        tooltip: "<strong>United States</strong><p>10,000+ students</p><p>45% success rate</p>",
    },
    {
        name: "Singapore",
        className: "marker-singapore",
        tooltip: "<strong>Singapore</strong><p>3000+ students</p><p>90% success rate</p>",
    },
    {
        name: "New Zealand",
        className: "marker-nz",
        tooltip: "<strong>New Zealand</strong><p>20,000+ students</p><p>90% success rate</p>",
    },
];

// Accept the isLoggedIn prop here
const Map = ({ isLoggedIn }) => {
  const [activeMarker, setActiveMarker] = useState(0);
  const [hoveredMarker, setHoveredMarker] = useState(null);

  useEffect(() => {
    if (hoveredMarker !== null) {
      return;
    }
    const interval = setInterval(() => {
      setActiveMarker((prev) => (prev + 1) % markers.length);
    }, 3000);
    return () => clearInterval(interval);
  }, [hoveredMarker]);

  const visibleMarkerIndex = hoveredMarker !== null ? hoveredMarker : activeMarker;

  return (
    <div className="map-container">
      <h2 className="map-title">Top Trending Destinations</h2>
      <p className="map-subtitle">
        Discover where students like you found success and opportunities around
        the globe.
      </p>
      <div className="map-wrapper">
        <img src={new1Map} alt="World Map" className="map-background" />
        {markers.map((marker, index) => (
          <div
            key={marker.name}
            className={`custom-marker ${marker.className}`}
            onMouseEnter={() => setHoveredMarker(index)}
            onMouseLeave={() => setHoveredMarker(null)}
          ></div>
        ))}
      </div>

      <Tooltip
        id="map-tooltip"
        anchorSelect={`.${markers[visibleMarkerIndex].className}`}
        isOpen={true}
        html={markers[visibleMarkerIndex].tooltip}
        place="top"
      />

      <div className="trending-destinations-container">
        <div className="trending-header">
          <h3>Trending Destinations</h3>
          {/* --- MODIFICATION HERE --- */}
          {isLoggedIn ? (
            <Link to="/dashboard?view=get-ai-report" className="find-fit-button">
              Find Your Fit
            </Link>
          ) : (
            <button className="find-fit-button trigger-login-popup">
              Find Your Fit
            </button>
          )}
        </div>

        <Slider {...sliderSettings}>
          <div className="destination-slide">
            <div className="destination-card">
              <div className="destination-in">
                <img src="https://flagcdn.com/w40/au.png" alt="Australia Work Visa" />
                <p>Australia</p>
              </div>
              <div className="destination-info">
                <span>Successful Applicants: 10,000+</span>
                <span>Average Cost: $50,000 (AUD)</span>
                <span>Visa Success Rate: 60%</span>
              </div>
            </div>
          </div>
          <div className="destination-slide">
            <div className="destination-card">
              <div className="destination-in">
                <img src="https://flagcdn.com/w40/in.png" alt="New Zealand Work Visa" />
                <p>India</p>
              </div>
              <div className="destination-info">
                <span>Successful Applicants: 2000+</span>
                <span>Average Cost: 10,00,000 (INR)</span>
                <span>Visa Success Rate: 80%</span>
              </div>
            </div>
          </div>
          <div className="destination-slide">
            <div className="destination-card">
              <div className="destination-in">
                <img src="https://flagcdn.com/w40/ca.png" alt="USA Work Visa" />
                <p>Canada</p>
              </div>
              <div className="destination-info">
                <span>Successful Applicants: 20,000+</span>
                <span>Average Cost: $40,000 (CAD)</span>
                <span>Visa Success Rate: 50%</span>
              </div>
            </div>
          </div>
          <div className="destination-slide">
            <div className="destination-card">
              <div className="destination-in">
                <img src="https://flagcdn.com/w40/de.png" alt="Germany Work Visa" />
                <p>Germany</p>
              </div>
              <div className="destination-info">
                <span>Successful Applicants: 10,000+</span>
                <span>Average Cost:€12,000 (EURO)</span>
                <span>Visa Success Rate: 85%</span>
              </div>
            </div>
          </div>
          <div className="destination-slide">
            <div className="destination-card">
              <div className="destination-in">
                <img src="https://flagcdn.com/w40/gb.png" alt="United Kingdom Work Visa" />
                <p>United Kingdom</p>
              </div>
              <div className="destination-info">
                <span>Successful Applicants: 30,000+</span>
                <span>Average Cost:£25,000 (EURO) </span>
                <span>Visa Success Rate: 95%</span>
              </div>
            </div>
          </div>
          <div className="destination-slide">
            <div className="destination-card">
              <div className="destination-in">
                <img src="https://flagcdn.com/w40/us.png" alt="UK work visa" />
                <p>United States</p>
              </div>
              <div className="destination-info">
                <span>Successful Applicants: 10,000+</span>
                <span>Average Cost: $50,000 (USD)</span>
                <span>Visa Success Rate: 45% </span>
              </div>
            </div>
          </div>
          <div className="destination-slide">
            <div className="destination-card">
              <div className="destination-in">
                <img src="https://flagcdn.com/w40/sg.png" alt="Canada Work Visa" />
                <p>Singapore</p>
              </div>
              <div className="destination-info">
                <span>Successful Applicants: 3,000+</span>
                <span>Average Cost: $35,000 (SGD)</span>
                <span>Visa Success Rate: 90%</span>
              </div>
            </div>
          </div>
          <div className="destination-slide">
            <div className="destination-card">
              <div className="destination-in">
                <img src="https://flagcdn.com/w40/nz.png" alt="Canada PNP Process" />
                <p>New Zealand</p>
              </div>
              <div className="destination-info">
                <span>Successful Applicants: 20,000+</span>
                <span>Average Cost: $40,000 (NZD)</span>
                <span>Visa Success Rate: 85%</span>
              </div>
            </div>
          </div>
        </Slider>
      </div>
    </div>
  );
};

export default Map;